export enum AppLocale {
  English = 'en',
  Spanish = 'es',
}

export enum StateCode {
  Wisconsin = 'WI',
  Iowa = 'IA',
}

export enum SeasonEnum {
  All = 'all',
  Summer = 'summer',
  Winter = 'winter',
}

export enum CustomerAddressTypeEnum {
  PUBLSTLT = 'PUBLSTLT',
  IND = 'IND',
  WHLSL = 'WHLSL',
  CMPUSE = 'CMPUSE',
  FARM = 'FARM',
  RES = 'RES',
  COM = 'COM',
}
